import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";

export const authenticateUserRequest = async (
    email: string,
    invitationToken: string,
    idp: string
) => {
    const route = apiRoutes.axnadminCore.authenticateUser;

    const body = {
        email,
        invitationToken,
        idp
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error };
};